import { connect } from 'react-redux'

import { setAlert } from '../../actions/adminActions'

import { Alert } from '../components/Alert'

/** Selectors */
const getAlert = state => state.alert || {}
const getAlertDisplay = state => getAlert(state).display || {}
const getAlertDisplayShow = state => getAlertDisplay(state).show || false
const getAlertDisplayMessage = state => getAlertDisplay(state).message || false
const getAlertDisplayBsStyle = state => getAlertDisplay(state).BsStyle || 'danger'

/** Selected State to Props */
const mapStateToProps = state => ({
  show: getAlertDisplayShow(state),
  message: getAlertDisplayMessage(state),
  bsStyle: getAlertDisplayBsStyle(state),
})

const mapDispatchToProps = dispatch => ({
  closeAlert: () => dispatch(setAlert({ show: false, message: '', bsStyle: '' }))
})

/** HoC Creator */
const withAlertDisplay = connect(mapStateToProps, mapDispatchToProps)

/** Global Alert with Connected State */
export default withAlertDisplay(Alert)
